import PAApi from './_paApi.js';
import httpClient from '@/apis/base/httpclient';

class PAPersonalIncomeTaxAPI extends PAApi {
  constructor() {
    super();
  }
  controllerName = 'PAPersonalIncomeTaxs';

  /**
   * Hàm lấy dữ liệu tài khoản chi tiết nhất theo thông tin tài khoản truyền vào
   * @param {*} payload
   * @returns
   * NHANH3 26.10.2022
   */
  async GetChildAccountData(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/ChildAccountData',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu nộp thuế theo thông tin bảng tính thuế truyền vào
   * @param {*} payload
   * @returns
   * NHANH3 26.10.2022
   */
  async GetPersonalIncomeTaxForPayment(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/PersonalIncomeTaxForPayment',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Kiểm tra xem có show cảnh báo kỳ tính thuế hay không
   * @param {*} payload
   * @returns
   * npcuong 28.10.2022
   */
  async checkShowTaxTransition(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/CheckShowTaxTransition',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /*
   * Hàm lấy dữ liệu sinh chứng từ nộp thuế theo thông tin bảng tính thuế
   * @param {*} payload
   * @returns
   * NHANH3 1.11.2022
   */
  async GetDataVoucherGeneratePayIncomeTax(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataGenerateVoucher',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   *
   * @param {*} payload
   * @returns
   */
  async getNew(payload) {
    let request = {
      url: this.getAPIUrl() + '/getnew',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Xuất khẩu báo cáo Xml
   * NHANH3 20.02.2024
   */
  export(param) {
    let request = {
      url: this.getAPIUrl() + '/Export',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new PAPersonalIncomeTaxAPI();
